{
    "data": [
        {
            "value": "af",
            "en": "Afghanistan",
            "es": "Afganistán"
        },
        {
            "value": "ax",
            "en": "Åland Islands",
            "es": "Åland"
        },
        {
            "value": "al",
            "en": "Albania",
            "es": "Albania"
        },
        {
            "value": "dz",
            "en": "Algeria",
            "es": "Argelia"
        },
        {
            "value": "as",
            "en": "American Samoa",
            "es": "Samoa Americana"
        },
        {
            "value": "ad",
            "en": "Andorra",
            "es": "Andorra"
        },
        {
            "value": "ao",
            "en": "Angola",
            "es": "Angola"
        },
        {
            "value": "ai",
            "en": "Anguilla",
            "es": "Anguila"
        },
        {
            "value": "aq",
            "en": "Antarctica",
            "es": "Antártida"
        },
        {
            "value": "ag",
            "en": "Antigua and Barbuda",
            "es": "Antigua y Barbuda"
        },
        {
            "value": "ar",
            "en": "Argentina",
            "es": "Argentina"
        },
        {
            "value": "am",
            "en": "Armenia",
            "es": "Armenia"
        },
        {
            "value": "aw",
            "en": "Aruba",
            "es": "Aruba"
        },
        {
            "value": "au",
            "en": "Australia",
            "es": "Australia"
        },
        {
            "value": "at",
            "en": "Austria",
            "es": "Austria"
        },
        {
            "value": "az",
            "en": "Azerbaijan",
            "es": "Azerbaiyán"
        },
        {
            "value": "bs",
            "en": "Bahamas",
            "es": "Bahamas"
        },
        {
            "value": "bh",
            "en": "Bahrain",
            "es": "Baréin"
        },
        {
            "value": "bd",
            "en": "Bangladesh",
            "es": "Bangladés"
        },
        {
            "value": "bb",
            "en": "Barbados",
            "es": "Barbados"
        },
        {
            "value": "by",
            "en": "Belarus",
            "es": "Bielorrusia"
        },
        {
            "value": "be",
            "en": "Belgium",
            "es": "Bélgica"
        },
        {
            "value": "bz",
            "en": "Belize",
            "es": "Belice"
        },
        {
            "value": "bj",
            "en": "Benin",
            "es": "Benín"
        },
        {
            "value": "bm",
            "en": "Bermuda",
            "es": "Bermudas"
        },
        {
            "value": "bt",
            "en": "Bhutan",
            "es": "Bután"
        },
        {
            "value": "bo",
            "en": "Bolivia Plurinational State of",
            "es": "Bolivia"
        },
        {
            "value": "bq",
            "en": "Bonaire Sint Eustatius and Saba",
            "es": "Bonaire San Eustaquio y Saba"
        },
        {
            "value": "ba",
            "en": "Bosnia and Herzegovina",
            "es": "Bosnia y Herzegovina"
        },
        {
            "value": "bw",
            "en": "Botswana",
            "es": "Botsuana"
        },
        {
            "value": "bv",
            "en": "Bouvet Island",
            "es": "Isla Bouvet"
        },
        {
            "value": "br",
            "en": "Brazil",
            "es": "Brasil"
        },
        {
            "value": "io",
            "en": "British Indian Ocean Territory",
            "es": "Territorio Británico del Océano Índico"
        },
        {
            "value": "bn",
            "en": "Brunei Darussalam",
            "es": "Brunéi"
        },
        {
            "value": "bg",
            "en": "Bulgaria",
            "es": "Bulgaria"
        },
        {
            "value": "bf",
            "en": "Burkina Faso",
            "es": "Burkina Faso"
        },
        {
            "value": "bi",
            "en": "Burundi",
            "es": "Burundi"
        },
        {
            "value": "kh",
            "en": "Cambodia",
            "es": "Camboya"
        },
        {
            "value": "cm",
            "en": "Cameroon",
            "es": "Camerún"
        },
        {
            "value": "ca",
            "en": "Canada",
            "es": "Canadá"
        },
        {
            "value": "cv",
            "en": "Cabo Verde",
            "es": "Cabo Verde"
        },
        {
            "value": "ky",
            "en": "Cayman Islands",
            "es": "Islas Caimán"
        },
        {
            "value": "cf",
            "en": "Central African Republic",
            "es": "República Centroafricana"
        },
        {
            "value": "td",
            "en": "Chad",
            "es": "Chad"
        },
        {
            "value": "cl",
            "en": "Chile",
            "es": "Chile"
        },
        {
            "value": "cn",
            "en": "China",
            "es": "China"
        },
        {
            "value": "cx",
            "en": "Christmas Island",
            "es": "Isla de Navidad"
        },
        {
            "value": "cc",
            "en": "Cocos (Keeling) Islands",
            "es": "Islas Cocos"
        },
        {
            "value": "co",
            "en": "Colombia",
            "es": "Colombia"
        },
        {
            "value": "km",
            "en": "Comoros",
            "es": "Comoras"
        },
        {
            "value": "cg",
            "en": "Congo",
            "es": "República del Congo"
        },
        {
            "value": "cd",
            "en": "Congo Democratic Republic of the",
            "es": "República Democrática del Congo"
        },
        {
            "value": "ck",
            "en": "Cook Islands",
            "es": "Islas Cook"
        },
        {
            "value": "cr",
            "en": "Costa Rica",
            "es": "Costa Rica"
        },
        {
            "value": "ci",
            "en": "Côte dIvoire",
            "es": "Costa de Marfil"
        },
        {
            "value": "hr",
            "en": "Croatia",
            "es": "Croacia"
        },
        {
            "value": "cu",
            "en": "Cuba",
            "es": "Cuba"
        },
        {
            "value": "cw",
            "en": "Curaçao",
            "es": "Curazao"
        },
        {
            "value": "cy",
            "en": "Cyprus",
            "es": "Chipre"
        },
        {
            "value": "cz",
            "en": "Czechia",
            "es": "República Checa"
        },
        {
            "value": "dk",
            "en": "Denmark",
            "es": "Dinamarca"
        },
        {
            "value": "dj",
            "en": "Djibouti",
            "es": "Yibuti"
        },
        {
            "value": "dm",
            "en": "Dominica",
            "es": "Dominica"
        },
        {
            "value": "do",
            "en": "Dominican Republic",
            "es": "República Dominicana"
        },
        {
            "value": "ec",
            "en": "Ecuador",
            "es": "Ecuador"
        },
        {
            "value": "eg",
            "en": "Egypt",
            "es": "Egipto"
        },
        {
            "value": "sv",
            "en": "El Salvador",
            "es": "El Salvador"
        },
        {
            "value": "gq",
            "en": "Equatorial Guinea",
            "es": "Guinea Ecuatorial"
        },
        {
            "value": "er",
            "en": "Eritrea",
            "es": "Eritrea"
        },
        {
            "value": "ee",
            "en": "Estonia",
            "es": "Estonia"
        },
        {
            "value": "et",
            "en": "Ethiopia",
            "es": "Etiopía"
        },
        {
            "value": "fk",
            "en": "Falkland Islands (Malvinas)",
            "es": "Islas Malvinas"
        },
        {
            "value": "fo",
            "en": "Faroe Islands",
            "es": "Islas Feroe"
        },
        {
            "value": "fj",
            "en": "Fiji",
            "es": "Fiyi"
        },
        {
            "value": "fi",
            "en": "Finland",
            "es": "Finlandia"
        },
        {
            "value": "fr",
            "en": "France",
            "es": "Francia"
        },
        {
            "value": "gf",
            "en": "French Guiana",
            "es": "Guayana Francesa"
        },
        {
            "value": "pf",
            "en": "French Polynesia",
            "es": "Polinesia Francesa"
        },
        {
            "value": "tf",
            "en": "French Southern Territories",
            "es": "Tierras Australes y Antárticas Francesas"
        },
        {
            "value": "ga",
            "en": "Gabon",
            "es": "Gabón"
        },
        {
            "value": "gm",
            "en": "Gambia",
            "es": "Gambia"
        },
        {
            "value": "ge",
            "en": "Georgia",
            "es": "Georgia"
        },
        {
            "value": "de",
            "en": "Germany",
            "es": "Alemania"
        },
        {
            "value": "gh",
            "en": "Ghana",
            "es": "Ghana"
        },
        {
            "value": "gi",
            "en": "Gibraltar",
            "es": "Gibraltar"
        },
        {
            "value": "gr",
            "en": "Greece",
            "es": "Grecia"
        },
        {
            "value": "gl",
            "en": "Greenland",
            "es": "Groenlandia"
        },
        {
            "value": "gd",
            "en": "Grenada",
            "es": "Granada"
        },
        {
            "value": "gp",
            "en": "Guadeloupe",
            "es": "Guadalupe"
        },
        {
            "value": "gu",
            "en": "Guam",
            "es": "Guam"
        },
        {
            "value": "gt",
            "en": "Guatemala",
            "es": "Guatemala"
        },
        {
            "value": "gg",
            "en": "Guernsey",
            "es": "Guernsey"
        },
        {
            "value": "gn",
            "en": "Guinea",
            "es": "Guinea"
        },
        {
            "value": "gw",
            "en": "Guinea-Bissau",
            "es": "Guinea-Bisáu"
        },
        {
            "value": "gy",
            "en": "Guyana",
            "es": "Guyana"
        },
        {
            "value": "ht",
            "en": "Haiti",
            "es": "Haití"
        },
        {
            "value": "hm",
            "en": "Heard Island and McDonald Islands",
            "es": "Islas Heard y McDonald"
        },
        {
            "value": "va",
            "en": "Holy See",
            "es": "Vaticano Ciudad del"
        },
        {
            "value": "hn",
            "en": "Honduras",
            "es": "Honduras"
        },
        {
            "value": "hk",
            "en": "Hong Kong",
            "es": "Hong Kong"
        },
        {
            "value": "hu",
            "en": "Hungary",
            "es": "Hungría"
        },
        {
            "value": "is",
            "en": "Iceland",
            "es": "Islandia"
        },
        {
            "value": "in",
            "en": "India",
            "es": "India"
        },
        {
            "value": "id",
            "en": "Indonesia",
            "es": "Indonesia"
        },
        {
            "value": "ir",
            "en": "Iran Islamic Republic of",
            "es": "Irán"
        },
        {
            "value": "iq",
            "en": "Iraq",
            "es": "Irak"
        },
        {
            "value": "ie",
            "en": "Ireland",
            "es": "Irlanda"
        },
        {
            "value": "im",
            "en": "Isle of Man",
            "es": "Isla de Man"
        },
        {
            "value": "il",
            "en": "Israel",
            "es": "Israel"
        },
        {
            "value": "it",
            "en": "Italy",
            "es": "Italia"
        },
        {
            "value": "jm",
            "en": "Jamaica",
            "es": "Jamaica"
        },
        {
            "value": "jp",
            "en": "Japan",
            "es": "Japón"
        },
        {
            "value": "je",
            "en": "Jersey",
            "es": "Jersey"
        },
        {
            "value": "jo",
            "en": "Jordan",
            "es": "Jordania"
        },
        {
            "value": "kz",
            "en": "Kazakhstan",
            "es": "Kazajistán"
        },
        {
            "value": "ke",
            "en": "Kenya",
            "es": "Kenia"
        },
        {
            "value": "ki",
            "en": "Kiribati",
            "es": "Kiribati"
        },
        {
            "value": "kp",
            "en": "Korea Democratic People",
            "es": "Corea del Norte"
        },
        {
            "value": "kr",
            "en": "Korea Republic of",
            "es": "Corea del Sur"
        },
        {
            "value": "kw",
            "en": "Kuwait",
            "es": "Kuwait"
        },
        {
            "value": "kg",
            "en": "Kyrgyzstan",
            "es": "Kirguistán"
        },
        {
            "value": "la",
            "en": "Lao People',s Democratic Republic",
            "es": "Laos"
        },
        {
            "value": "lv",
            "en": "Latvia",
            "es": "Letonia"
        },
        {
            "value": "lb",
            "en": "Lebanon",
            "es": "Líbano"
        },
        {
            "value": "ls",
            "en": "Lesotho",
            "es": "Lesoto"
        },
        {
            "value": "lr",
            "en": "Liberia",
            "es": "Liberia"
        },
        {
            "value": "ly",
            "en": "Libya",
            "es": "Libia"
        },
        {
            "value": "li",
            "en": "Liechtenstein",
            "es": "Liechtenstein"
        },
        {
            "value": "lt",
            "en": "Lithuania",
            "es": "Lituania"
        },
        {
            "value": "lu",
            "en": "Luxembourg",
            "es": "Luxemburgo"
        },
        {
            "value": "mo",
            "en": "Macao",
            "es": "Macao"
        },
        {
            "value": "mk",
            "en": "North Macedonia",
            "es": "Macedonia del Norte"
        },
        {
            "value": "mg",
            "en": "Madagascar",
            "es": "Madagascar"
        },
        {
            "value": "mw",
            "en": "Malawi",
            "es": "Malaui"
        },
        {
            "value": "my",
            "en": "Malaysia",
            "es": "Malasia"
        },
        {
            "value": "mv",
            "en": "Maldives",
            "es": "Maldivas"
        },
        {
            "value": "ml",
            "en": "Mali",
            "es": "Malí"
        },
        {
            "value": "mt",
            "en": "Malta",
            "es": "Malta"
        },
        {
            "value": "mh",
            "en": "Marshall Islands",
            "es": "Islas Marshall"
        },
        {
            "value": "mq",
            "en": "Martinique",
            "es": "Martinica"
        },
        {
            "value": "mr",
            "en": "Mauritania",
            "es": "Mauritania"
        },
        {
            "value": "mu",
            "en": "Mauritius",
            "es": "Mauricio"
        },
        {
            "value": "yt",
            "en": "Mayotte",
            "es": "Mayotte"
        },
        {
            "value": "mx",
            "en": "Mexico",
            "es": "México"
        },
        {
            "value": "fm",
            "en": "Micronesia Federated States of",
            "es": "Micronesia"
        },
        {
            "value": "ma",
            "en": "Morocco",
            "es": "Marruecos"
        },
        {
            "value": "md",
            "en": "Moldova Republic of",
            "es": "Moldavia"
        },
        {
            "value": "mc",
            "en": "Monaco",
            "es": "Mónaco"
        },
        {
            "value": "mn",
            "en": "Mongolia",
            "es": "Mongolia"
        },
        {
            "value": "me",
            "en": "Montenegro",
            "es": "Montenegro"
        },
        {
            "value": "ms",
            "en": "Montserrat",
            "es": "Montserrat"
        },
        {
            "value": "mz",
            "en": "Mozambique",
            "es": "Mozambique"
        },
        {
            "value": "mm",
            "en": "Myanmar",
            "es": "Birmania"
        },
        {
            "value": "na",
            "en": "Namibia",
            "es": "Namibia"
        },
        {
            "value": "nr",
            "en": "Nauru",
            "es": "Nauru"
        },
        {
            "value": "np",
            "en": "Nepal",
            "es": "Nepal"
        },
        {
            "value": "nl",
            "en": "Netherlands",
            "es": "Países Bajos"
        },
        {
            "value": "nc",
            "en": "New Caledonia",
            "es": "Nueva Caledonia"
        },
        {
            "value": "nz",
            "en": "New Zealand",
            "es": "Nueva Zelanda"
        },
        {
            "value": "ni",
            "en": "Nicaragua",
            "es": "Nicaragua"
        },
        {
            "value": "ne",
            "en": "Niger",
            "es": "Níger"
        },
        {
            "value": "ng",
            "en": "Nigeria",
            "es": "Nigeria"
        },
        {
            "value": "nu",
            "en": "Niue",
            "es": "Niue"
        },
        {
            "value": "nf",
            "en": "Norfolk Island",
            "es": "Isla Norfolk"
        },
        {
            "value": "mp",
            "en": "Northern Mariana Islands",
            "es": "Islas Marianas del Norte"
        },
        {
            "value": "no",
            "en": "Norway",
            "es": "Noruega"
        },
        {
            "value": "om",
            "en": "Oman",
            "es": "Omán"
        },
        {
            "value": "pk",
            "en": "Pakistan",
            "es": "Pakistán"
        },
        {
            "value": "pw",
            "en": "Palau",
            "es": "Palaos"
        },
        {
            "value": "ps",
            "en": "Palestine State of",
            "es": "Palestina"
        },
        {
            "value": "pa",
            "en": "Panama",
            "es": "Panamá"
        },
        {
            "value": "pg",
            "en": "Papua New Guinea",
            "es": "Papúa Nueva Guinea"
        },
        {
            "value": "py",
            "en": "Paraguay",
            "es": "Paraguay"
        },
        {
            "value": "pe",
            "en": "Peru",
            "es": "Perú"
        },
        {
            "value": "ph",
            "en": "Philippines",
            "es": "Filipinas"
        },
        {
            "value": "pn",
            "en": "Pitcairn",
            "es": "Islas Pitcairn"
        },
        {
            "value": "pl",
            "en": "Poland",
            "es": "Polonia"
        },
        {
            "value": "pt",
            "en": "Portugal",
            "es": "Portugal"
        },
        {
            "value": "pr",
            "en": "Puerto Rico",
            "es": "Puerto Rico"
        },
        {
            "value": "qa",
            "en": "Qatar",
            "es": "Catar"
        },
        {
            "value": "re",
            "en": "Réunion",
            "es": "Reunión"
        },
        {
            "value": "ro",
            "en": "Romania",
            "es": "Rumania"
        },
        {
            "value": "ru",
            "en": "Russian Federation",
            "es": "Rusia"
        },
        {
            "value": "rw",
            "en": "Rwanda",
            "es": "Ruanda"
        },
        {
            "value": "bl",
            "en": "Saint Barthélemy",
            "es": "San Bartolomé"
        },
        {
            "value": "sh",
            "en": "Saint Helena Ascension and Tristan da Cunha",
            "es": "Santa Elena Ascensión y Tristán de Acuña"
        },
        {
            "value": "kn",
            "en": "Saint Kitts and Nevis",
            "es": "San Cristóbal y Nieves"
        },
        {
            "value": "lc",
            "en": "Saint Lucia",
            "es": "Santa Lucía"
        },
        {
            "value": "mf",
            "en": "Saint Martin (French part)",
            "es": "San Martín"
        },
        {
            "value": "pm",
            "en": "Saint Pierre and Miquelon",
            "es": "San Pedro y Miquelón"
        },
        {
            "value": "vc",
            "en": "Saint Vincent and the Grenadines",
            "es": "San Vicente y las Granadinas"
        },
        {
            "value": "ws",
            "en": "Samoa",
            "es": "Samoa"
        },
        {
            "value": "sm",
            "en": "San Marino",
            "es": "San Marino"
        },
        {
            "value": "st",
            "en": "Sao Tome and Principe",
            "es": "Santo Tomé y Príncipe"
        },
        {
            "value": "sa",
            "en": "Saudi Arabia",
            "es": "Arabia Saudita"
        },
        {
            "value": "sn",
            "en": "Senegal",
            "es": "Senegal"
        },
        {
            "value": "rs",
            "en": "Serbia",
            "es": "Serbia"
        },
        {
            "value": "sc",
            "en": "Seychelles",
            "es": "Seychelles"
        },
        {
            "value": "sl",
            "en": "Sierra Leone",
            "es": "Sierra Leona"
        },
        {
            "value": "sg",
            "en": "Singapore",
            "es": "Singapur"
        },
        {
            "value": "sx",
            "en": "Sint Maarten (Dutch part)",
            "es": "San Martín"
        },
        {
            "value": "sk",
            "en": "Slovakia",
            "es": "Eslovaquia"
        },
        {
            "value": "si",
            "en": "Slovenia",
            "es": "Eslovenia"
        },
        {
            "value": "sb",
            "en": "Solomon Islands",
            "es": "Islas Salomón"
        },
        {
            "value": "so",
            "en": "Somalia",
            "es": "Somalia"
        },
        {
            "value": "za",
            "en": "South Africa",
            "es": "Sudáfrica"
        },
        {
            "value": "gs",
            "en": "South Georgia and the South Sandwich Islands",
            "es": "Islas Georgias del Sur y Sandwich del Sur"
        },
        {
            "value": "ss",
            "en": "South Sudan",
            "es": "Sudán del Sur"
        },
        {
            "value": "es",
            "en": "Spain",
            "es": "España"
        },
        {
            "value": "lk",
            "en": "Sri Lanka",
            "es": "Sri Lanka"
        },
        {
            "value": "sd",
            "en": "Sudan",
            "es": "Sudán"
        },
        {
            "value": "sr",
            "en": "Suriname",
            "es": "Surinam"
        },
        {
            "value": "sj",
            "en": "Svalbard and Jan Mayen",
            "es": "Svalbard y Jan Mayen"
        },
        {
            "value": "sz",
            "en": "Eswatini",
            "es": "Suazilandia"
        },
        {
            "value": "se",
            "en": "Sweden",
            "es": "Suecia"
        },
        {
            "value": "ch",
            "en": "Switzerland",
            "es": "Suiza"
        },
        {
            "value": "sy",
            "en": "Syrian Arab Republic",
            "es": "Siria"
        },
        {
            "value": "tw",
            "en": "Taiwan Province of China",
            "es": "Taiwán (República de China)"
        },
        {
            "value": "tj",
            "en": "Tajikistan",
            "es": "Tayikistán"
        },
        {
            "value": "tz",
            "en": "Tanzania United Republic of",
            "es": "Tanzania"
        },
        {
            "value": "th",
            "en": "Thailand",
            "es": "Tailandia"
        },
        {
            "value": "tl",
            "en": "Timor-Leste",
            "es": "Timor Oriental"
        },
        {
            "value": "tg",
            "en": "Togo",
            "es": "Togo"
        },
        {
            "value": "tk",
            "en": "Tokelau",
            "es": "Tokelau"
        },
        {
            "value": "to",
            "en": "Tonga",
            "es": "Tonga"
        },
        {
            "value": "tt",
            "en": "Trinidad and Tobago",
            "es": "Trinidad y Tobago"
        },
        {
            "value": "tn",
            "en": "Tunisia",
            "es": "Túnez"
        },
        {
            "value": "tr",
            "en": "Türkiye",
            "es": "Turquía"
        },
        {
            "value": "tm",
            "en": "Turkmenistan",
            "es": "Turkmenistán"
        },
        {
            "value": "tc",
            "en": "Turks and Caicos Islands",
            "es": "Islas Turcas y Caicos"
        },
        {
            "value": "tv",
            "en": "Tuvalu",
            "es": "Tuvalu"
        },
        {
            "value": "ug",
            "en": "Uganda",
            "es": "Uganda"
        },
        {
            "value": "ua",
            "en": "Ukraine",
            "es": "Ucrania"
        },
        {
            "value": "ae",
            "en": "United Arab Emirates",
            "es": "Emiratos Árabes Unidos"
        },
        {
            "value": "gb",
            "en": "United Kingdom of Great Britain and Northern Ireland",
            "es": "Reino Unido"
        },
        {
            "value": "us",
            "en": "United States of America",
            "es": "Estados Unidos"
        },
        {
            "value": "um",
            "en": "United States Minor Outlying Islands",
            "es": "Islas Ultramarinas Menores de los Estados Unidos"
        },
        {
            "value": "uy",
            "en": "Uruguay",
            "es": "Uruguay"
        },
        {
            "value": "uz",
            "en": "Uzbekistan",
            "es": "Uzbekistán"
        },
        {
            "value": "vu",
            "en": "Vanuatu",
            "es": "Vanuatu"
        },
        {
            "value": "ve",
            "en": "Venezuela Bolivarian Republic of",
            "es": "Venezuela"
        },
        {
            "value": "vn",
            "en": "Viet Nam",
            "es": "Vietnam"
        },
        {
            "value": "vg",
            "en": "Virgin Islands (British)",
            "es": "Islas Vírgenes Británicas"
        },
        {
            "value": "vi",
            "en": "Virgin Islands (U.S.)",
            "es": "Islas Vírgenes de los Estados Unidos"
        },
        {
            "value": "wf",
            "en": "Wallis and Futuna",
            "es": "Wallis y Futuna"
        },
        {
            "value": "eh",
            "en": "Western Sahara",
            "es": "República Árabe Saharaui Democrática"
        },
        {
            "value": "ye",
            "en": "Yemen",
            "es": "Yemen"
        },
        {
            "value": "zm",
            "en": "Zambia",
            "es": "Zambia"
        },
        {
            "value": "zw",
            "en": "Zimbabwe",
            "es": "Zimbabue"
        }
    ]
}